import { TranslatableNameCodebook } from '../TranslatableNameCodebook'
import { $t } from '../../composables/i18n'
import { Color } from '../color/Color'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

type LicenseColor = Color.NEGATIVE | Color.INFO | Color.POSITIVE | Color.WARNING | Color.GREY_600

export enum LicenseId {
  NONE = 1,
  PRO = 2,
  LITE = 3,
  CONNECT = 4,
  SCHOOL = 7,
}

export class License extends TranslatableNameCodebook {
  static readonly NONE = new License(LicenseId.NONE, $t('None'))
  static readonly PRO = new License(LicenseId.PRO, $t('Pro'))
  static readonly LITE = new License(LicenseId.LITE, $t('Lite'))
  static readonly CONNECT = new License(LicenseId.CONNECT, $t('Connect'))
  static readonly SCHOOL = new License(LicenseId.SCHOOL, $t('School'))

  private constructor(
    public readonly id: LicenseId,
    name: string,
  ) {
    super(name)
  }

  getColor = (): LicenseColor => {
    switch (this.id) {
      case LicenseId.NONE:
        return Color.NEGATIVE
      case LicenseId.PRO:
        return Color.INFO
      case LicenseId.LITE:
        return Color.POSITIVE
      case LicenseId.CONNECT:
        return Color.WARNING
      case LicenseId.SCHOOL:
        return Color.GREY_600
      default:
        return Color.INFO
    }
  }

  getShortcut = (): string => {
    switch (this.id) {
      case LicenseId.NONE:
        return 'NONE'
      case LicenseId.PRO:
        return 'PRO'
      case LicenseId.LITE:
        return 'LITE'
      case LicenseId.CONNECT:
        return 'CONN'
      case LicenseId.SCHOOL:
        return 'SCHO'
      default:
        return this.name
    }
  }

  static getById = (id: LicenseId): License => {
    const value = License.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(License.name, id)
    }

    return value
  }

  static all = (): License[] => {
    return [
      License.NONE, // Keep each item on new line
      License.PRO,
      License.LITE,
      License.CONNECT,
      License.SCHOOL,
    ]
  }
}
